import React from 'react';
import { HeroContent } from './HeroContent';
import { HeroQuotePanel } from './HeroQuotePanel';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Reviews } from './Reviews';
import { Comparison } from './Comparison';
import { ProblemSolution } from './ProblemSolution';
import { DoorGlass } from './DoorGlass';
import { Process } from './Process';
import { ShowerGlass } from './ShowerGlass';
import { Mirrors } from './Mirrors';
import { DeckScreens } from './DeckScreens';
import { WhyChooseUs } from './WhyChooseUs';
import { ServiceArea } from './ServiceArea';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { StickyMobileCTA } from './StickyMobileCTA';
export function ResidentialGlass() {
  return <main className="w-full bg-white pb-20 lg:pb-0" data-id="element-187">
      <section className="bg-white pt-8 pb-12 lg:pt-10 lg:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start" data-id="element-189">
          <HeroContent data-id="element-190" />
          <HeroQuotePanel data-id="element-191" />
        </div>
      </section>
      <TrustBar data-id="element-192" />
      <Services data-id="element-193" />
      <Reviews data-id="element-194" />
      <Comparison data-id="element-195" />
      <ProblemSolution data-id="element-196" />
      <DoorGlass data-id="element-197" />
      <Process data-id="element-198" />
      <ShowerGlass data-id="element-199" />
      <Mirrors data-id="element-200" />
      <DeckScreens data-id="element-201" />
      <WhyChooseUs data-id="element-202" />
      <ServiceArea data-id="element-203" />
      <FAQSection data-id="element-204" />
      <FinalCTA data-id="element-205" />
      <StickyMobileCTA data-id="element-206" />
    </main>;
}